import { getBankingProductsByType } from '@repo/accounts-services'
import { defineSagaForService } from '@repo/core'
import { bankingProductsDataActions } from '../../../../slices'

export const serviceConfig = defineSagaForService({
  [bankingProductsDataActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getBankingProductsByType,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: bankingProductsDataActions.getResponse.type,
    actionTypeRequest: bankingProductsDataActions.getRequest.type,
  },
  [bankingProductsDataActions.refreshRequest.type]: {
    apiClientDomain: 'accounts',
    service: getBankingProductsByType,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: bankingProductsDataActions.refreshResponse.type,
    actionTypeRequest: bankingProductsDataActions.refreshRequest.type,
  },
})
